<template>
    <el-form ref="form" :model="form" v-loading="isBusy" :rules="rules">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item prop="contact_id">
                    <contact-select-custom
                            class="w-100"
                            :url="contactSearchUrl"
                            v-model="selectedContact"
                            @search="onContactSearchPerformed"
                    ></contact-select-custom>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item prop="outgoing_number_id">
                    <outgoing-number-select
                            class="w-100"
                            v-model="form.outgoing_number_id"
                            placeholder="Select Outgoing Number"
                            filterable
                            clearable
                            popperClass="custom-popper"
                            :outgoing-numbers="outgoingNumbers"
                            :formatter="formatOutgoingNumber"
                            :selected-contact="selectedContact"
                    ></outgoing-number-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item prop="message">
            <el-input
                    type="textarea"
                    placeholder="Enter Message..."
                    :autosize="{minRows:2, maxRows:6}"
                    v-model="form.message"
                    class="word-break-normal"
            >
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="save" v-if="hasContacts">SEND MESSAGE</el-button>
            <el-button type="primary" @click="createContact" v-if="!hasContacts">CREATE NEW CONTACT</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
  import Form from "./form";
  import ContactSelect from "./contact-select";
  import OutgoingNumberSelect from "./outgoing-number-select";
  import {modes} from "./types";

  export default {
    extends: Form,

    components: {
      'contact-select-custom': ContactSelect,
      OutgoingNumberSelect,
    },

    props: {
      contactSearchUrl: String,
    },

    data() {
      const form = {
        contact_id: null,
        outgoing_number_id: null,
        message: null,
      };

      return {
        form,
        rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
        hasContacts: true,
        selectedContact: null,
      };
    },

    computed: {
      /**
       * @return {Boolean}
       */
      hasSelectedContact() {
        return Boolean(this.form.contact_id);
      },
    },

    watch: {
      selectedContact(val) {
        this.form.contact_id = _.get(val, 'id', null);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      createContact() {
        this.$emit('change-mode', modes.create_send);
      },

      /**
       * @param {Boolean} hasContacts
       */
      onContactSearchPerformed({hasContacts}) {
        this.hasContacts = hasContacts;
      },
    },
  }
</script>
